import * as actions from '../actionTypes';
import { GET_PAYMENT_RECORDS, ADD_PAYMENT_RECORD, UPDATE_PAYMENT_RECORD, DELETE_PAYMENT_RECORD } from '../api';
import client from '../apolloClient';
import { updateStudentLocally } from './studentActions';

export const deletePayment = (paymentID) => async (dispatch, getState) => {
    try {
        const state = getState();
        const previousPaymentRecord = state.paymentRecords.find(pr => pr._id == paymentID);
        const student = state.students.find(student => student._id == previousPaymentRecord.student._id);
        await client.mutate({
            mutation: DELETE_PAYMENT_RECORD,
            variables: { input: paymentID },
        });
        const action = { type: actions.DELETE_PAYMENT_RECORD, payload: paymentID };
        dispatch(action);
        if (previousPaymentRecord.currency == student.currency) {
            const updatedDebt = student.debt + previousPaymentRecord.amount;
            const updatedStudent = { ...student, debt: updatedDebt };
            dispatch(updateStudentLocally(updatedStudent));
        }
    } catch (error) {
        console.log(error);
    }
}

export const setPaymentRecords = () => async (dispatch) => {
    try {
        const { data } = await client.query({
            query: GET_PAYMENT_RECORDS,
        });
        const payment_records = data.paymentRecords;
        const action = { type: actions.SET_PAYMENT_RECORDS, payload: payment_records };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}




export const addPaymentRecord = (paymentRecord) => async (dispatch, getState) => {
    try {
        const { data } = await client.mutate({
            mutation: ADD_PAYMENT_RECORD,
            variables: { input: paymentRecord },
        });
        const savedPaymentRecord = data.createPaymentRecord;
        const action = { type: actions.ADD_PAYMENT_RECORD, payload: savedPaymentRecord };
        dispatch(action);
        const state = getState();
        const student = state.students.find(student => student._id == paymentRecord.studentId);
        if (student.currency == paymentRecord.currency) {
            const updatedDebt = student.debt - savedPaymentRecord.amount;
            const updatedStudent = { ...student, debt: updatedDebt };
            dispatch(updateStudentLocally(updatedStudent));

        }

    } catch (error) {
        console.log(error);
    }
}


export const updatePayment = (paymentRecord) => async (dispatch, getState) => {
    try {
        const state = getState();
        const student = state.students.find(student => student._id === paymentRecord.studentId);
        const previousPaymentRecord = state.paymentRecords.find(pr => pr._id === paymentRecord.paymentRecordId);

        const { data } = await client.mutate({
            mutation: UPDATE_PAYMENT_RECORD,
            variables: { input: paymentRecord },
        });

        const savedPaymentRecord = data.updatePaymentRecord;
        const action = { type: actions.UPDATE_PAYMENT_RECORD, payload: savedPaymentRecord };
        dispatch(action);

        let updatedDebt = student.debt;

        if (previousPaymentRecord.currency === student.currency) {
            // Subtract previous payment amount from student's debt if the previous currency matched student's currency
            updatedDebt += previousPaymentRecord.amount;
        }

        if (savedPaymentRecord.currency === student.currency) {
            // Subtract new payment amount from student's debt if the new currency matches student's currency
            updatedDebt -= savedPaymentRecord.amount;
        }

        const updatedStudent = { ...student, debt: updatedDebt };
        dispatch(updateStudentLocally(updatedStudent));
    } catch (error) {
        console.error(error);
    }
};

